import React from 'react';
import { ICurrency } from 'src/apis/common';
import { IMaDirectPlanTier } from 'src/apis/plans';
import NumericalPlanProperty from '../NumericalPlanProperty';
import PricePlanProperty from '../PricePlanProperty';

export interface IProps {
  currency: ICurrency;
  tier: IMaDirectPlanTier;
}

const PlanTier: React.FC<IProps> = ({currency, tier}) => {
  return <>
    <PricePlanProperty currency={currency} label={'Base Price'} value={tier.basePrice} />
    <NumericalPlanProperty label={'Lead Limit'} value={tier.leadLimit} />
    <NumericalPlanProperty label={'Included Emails'} value={tier.firstEmailLimit} />
    <PricePlanProperty currency={currency} label={'1st Overage Price'} value={tier.firstEmailOveragePrice} />
    <NumericalPlanProperty label={'2nd Email Tier'} value={tier.secondEmailLimit} />
    <PricePlanProperty currency={currency} label={'2nd Overage Price'} value={tier.secondEmailOveragePrice} />
  </>
};

export default PlanTier;
